module.exports = __webpack_public_path__ + "img/discharge-defense-equipment.788d91fd.png";